import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';

const _c0 = function (a0) { return [a0]; };
class PortalLinkCardComponent {
    constructor() {
        this.portalLink = '/';
    }
    ngOnInit() { }
}
PortalLinkCardComponent.ɵfac = function PortalLinkCardComponent_Factory(t) { return new (t || PortalLinkCardComponent)(); };
PortalLinkCardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PortalLinkCardComponent, selectors: [["fgbcl-portal-link-card"]], inputs: { portalLink: "portalLink", portalLinkText: "portalLinkText" }, decls: 5, vars: 4, consts: [[1, "accessibility-only"], [1, "portal-link-card", "rounded", "shadow", "cursor-pointer", 3, "routerLink"], [1, "d-flex", "justify-content-center", "align-items-center", "h-100", "text-white", "font-weight-bold", "text-uppercase"]], template: function PortalLinkCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h2", 0);
        ɵngcc0.ɵɵtext(1, "Rewards Card");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "p", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(2, _c0, ctx.portalLink));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.portalLinkText, " ");
    } }, directives: [ɵngcc1.RouterLink], styles: [""] });
PortalLinkCardComponent.ctorParameters = () => [];
PortalLinkCardComponent.propDecorators = {
    portalLinkText: [{ type: Input }],
    portalLink: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PortalLinkCardComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-portal-link-card',
                template: "<h2 class=\"accessibility-only\">Rewards Card</h2>\r\n<div class=\"portal-link-card rounded shadow cursor-pointer\" [routerLink]=\"[portalLink]\">\r\n  <p class=\"d-flex justify-content-center align-items-center h-100 text-white font-weight-bold text-uppercase\">\r\n    {{ portalLinkText }}\r\n  </p>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { portalLink: [{
            type: Input
        }], portalLinkText: [{
            type: Input
        }] }); })();

class PortalLinkCardModule {
}
PortalLinkCardModule.ɵfac = function PortalLinkCardModule_Factory(t) { return new (t || PortalLinkCardModule)(); };
PortalLinkCardModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PortalLinkCardModule });
PortalLinkCardModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, RouterModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PortalLinkCardModule, { declarations: function () { return [PortalLinkCardComponent]; }, imports: function () { return [CommonModule, RouterModule]; }, exports: function () { return [PortalLinkCardComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PortalLinkCardModule, [{
        type: NgModule,
        args: [{
                declarations: [PortalLinkCardComponent],
                imports: [CommonModule, RouterModule],
                exports: [PortalLinkCardComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { PortalLinkCardComponent, PortalLinkCardModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-portal-link-card.js.map